import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Player.module.scss";
import PathContext from "../../context/path";
import StatesContext from "../../context/states";
import Timer from '../Timer';
const videoTimeParts = [
  [0, 35],
  [38.8, 84],
  [89.6, 103],
  [106.5, 139.5],
  [143.9, 165],
  [168.5, 196],
  [198.2, 216],
];
const Player = () => {
  const path = useContext(PathContext);
  const states = useContext(StatesContext);
  const btnTexts = [
    ['побольше отдыхать', 'побольше работать'],
    ['все радости офиса', 'все радости удалёнки'],
    ['заглянем на кухню?'],
    ['ответственность', 'проактивность', 'открытость', 'участие и внимание к людям'],
    ['личный вклад', 'работа в команде'],
    ['в центре человек', 'в центре технологии'],
    ['Голосовать за Газпромбанк'],
  ];
  const refVideo = useRef(null);
  const refWrap = useRef(null);
  const refFinal = useRef(null);
  const refTrack = useRef(null);
  const refSub = useRef(null);
  const refDots = useRef([]);
  const refBars = useRef([]);
  const { videoSound, videoSub, hideMain, updateTheme, theme, isMobile } = states;
  const [currentPartId, setCurrentPartId] = useState(0);
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [isAutoplaytDisable, setAutoplaytDisable] = useState(false);
  const [timerShown, setTimerShown] = useState(false);
  const [transitionJump, setTransitionJump] = useState(false);
  const [init, setInit] = useState(false);
  const updateTimeline = () => {
    if (currentPartId < videoTimeParts.length - 1) {
      setTimeout(() => {
        const video = refVideo.current;
        const nextId = currentPartId + 1;
        video.currentTime = videoTimeParts[nextId][0];
        setCurrentPartId(prev => prev + 1);
        setVideoPlaying(true);
      }, 300);

    }
    setTimerShown(false);
  }



  useEffect(() => {
    const video = refVideo.current;
    const visibilityHandler = () => {
      if (document.hidden) {
        video.pause();
      } else {
        if (videoPlaying) {
          video.play().then(() => {
            setAutoplaytDisable(false);
          }).catch(error => {
            setAutoplaytDisable(true);
            console.error('Error attempting to play', error);
          });
        }
      }
    }
    const handleWindowBlur = () => {
      if (video) {
        video.pause();
      }
    };

    const handleWindowFocus = () => {
      if (video && videoPlaying) {
        video.play().then(() => {
          setAutoplaytDisable(false);
        }).catch(error => {
          setAutoplaytDisable(true);
          console.error('Error attempting to play', error);
        });
      }
    };

    document.addEventListener('visibilitychange', visibilityHandler);
    window.addEventListener('blur', handleWindowBlur);
    window.addEventListener('focus', handleWindowFocus);
    return () => {
      window.removeEventListener('blur', handleWindowBlur);
      window.removeEventListener('focus', handleWindowFocus);
      document.removeEventListener('visibilitychange', visibilityHandler);
    }
  }, [videoPlaying]);

  useEffect(() => {
    const video = refVideo.current;
    setTimeout(() => {
      setVideoPlaying(true);
    }, 300);
  }, [isMobile]);


  useEffect(() => {
    const video = refVideo.current;
    if (video === null) return;
    video.textTracks[0].mode = "hidden";
    // video.playbackRate = 3.0
    if (videoPlaying) {
      video.play().then(() => {
        setAutoplaytDisable(false);
      }).catch(error => {
        setAutoplaytDisable(true);
        console.error('Error attempting to play', error);
      });
    } else {
      video.pause();
    }
  }, [videoPlaying, isMobile, init]);

  useEffect(() => {
    const video = refVideo.current;
    const track = refTrack.current;
    const sub = refSub.current;
    
    const timeupdateHandler = () => {
      if (!videoSub) {
        sub.style.display = 'none';
        return;
      };

      const cues = track.track.activeCues;
      if(cues === null) return;
      while (sub.firstChild) {
        sub.removeChild(sub.lastChild);
      }
      if (cues.length > 0) {
        // sub.textContent = cues[0].text;
        const lines = cues[0].text.split('\n');
        lines.forEach(line => {
          const span = document.createElement('span');
          span.textContent = line;
          sub.appendChild(span);
        });
        sub.style.display = '';
      } else {
        sub.style.display = 'none';
      }
    };
    video.addEventListener('timeupdate', timeupdateHandler);
    return () => {

      video.removeEventListener('timeupdate', timeupdateHandler);
    }
  }, [videoSub]);

  useEffect(() => {
    const video = refVideo.current;
    if (videoSound) {
      video.muted = false;
    } else {
      video.muted = true;
    }
  }, [videoSound, hideMain, isMobile, videoPlaying]);



  useEffect(() => {
    const video = refVideo.current;
    const bars = refBars.current;
    const dots = refDots.current;
    const final = refFinal.current;
    const currentBar = bars[currentPartId];
    const currentTimePart = videoTimeParts[currentPartId];
    const isNextId = currentPartId !== videoTimeParts.length - 1;
    let progress = 0;
    let isTimerShown = false;
    const updateBar = () => {
      progress = (video.currentTime - currentTimePart[0]) * 100 / (currentTimePart[1] - currentTimePart[0]);
      if (progress <= 100) {
        currentBar.style.width = `${Math.floor(progress)}%`;
      } else {
        currentBar.style.width = `100%`;
        if (currentPartId === 3 && isMobile) {
          updateTheme('hideShare');
        } else if (currentPartId === 6) {
          updateTheme('final');
          final.classList.add(styles.active);
        } else {
          updateTheme('white');
          final.classList.remove(styles.active);
        }
        if (!isTimerShown) {
          isTimerShown = true;
          setTimerShown(true);
        }
        if (isNextId && video.currentTime >= videoTimeParts[currentPartId][1]) {
          setVideoPlaying(false);
        }
        if (dots[currentPartId] !== undefined) {
          dots[currentPartId].classList.add(styles.active);
        }
      }
    };
    video.addEventListener("timeupdate", updateBar);
    return () => {
      video.removeEventListener("timeupdate", updateBar);
    }
  }, [currentPartId, updateTheme, isMobile]);

  const selectDot = (id) => {
    const bars = refBars.current;
    const dots = refDots.current;
    const video = refVideo.current;
    const final = refFinal.current;
    if (id === currentPartId && dots[id].classList.contains(styles.active)) return;
    video.currentTime = videoTimeParts[id][1] - 1;
    updateTheme('white');
    setTransitionJump(true);
    setCurrentPartId(id);
    setTimerShown(false);
    final.classList.remove(styles.active);
    setTimeout(() => {
      setVideoPlaying(true);
      // setTimerShown(true);
      setTransitionJump(false);
    }, 300);
    bars.forEach((element, index) => {
      element.style.transition = 'none'
      if (index <= id) {
        element.style.width = '100%';
        if (dots[index] !== undefined) {
          dots[index].classList.add(styles.active);
        }
      } else {
        element.style.width = '0%';

        if (dots[index] !== undefined) {
          dots[index].classList.remove(styles.active);
        }
      }
      setTimeout(() => {
        element.style.transition = ''
      }, 10);
    });
  }

  const restartTrigger = () => {
    const wrap = refWrap.current;
    const bars = refBars.current;
    const dots = refDots.current;
    const video = refVideo.current;
    const final = refFinal.current;
    wrap.classList.add(styles.hide);
    setVideoPlaying(false);
    setTimerShown(false);
    setTimeout(() => {
      setCurrentPartId(0);
      video.currentTime = videoTimeParts[0][0];
      updateTheme('white');
      bars.forEach((element, index) => {
        element.style.transition = 'none'
        element.style.width = '0%';
        if (dots[index] !== undefined) {
          dots[index].classList.remove(styles.active);
        }
        setTimeout(() => {
          element.style.transition = '';
        }, 10);
      });
    }, 300);
    setTimeout(() => {
      final.classList.remove(styles.active);
      wrap.classList.remove(styles.hide);
      setVideoPlaying(true);
    }, 600);

  }

  const playHandler = () => {
    const video = refVideo.current;
    video.muted = true;
    video.play().then(() => {
      setAutoplaytDisable(false);
      video.muted = false
    }).catch(error => {
      console.error('Error attempting to play', error);
    });

  }
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        {videoTimeParts.length > 0 ?
          <div className={theme === 'final' ? `${styles.timeline} ${styles.timeline_final}` : styles.timeline}>
            {videoTimeParts.map((element, index) => {
              return <div className={styles.timeline__part} key={`timeline-part-${index}`}>
                <div className={styles.timeline__progress}>
                  <div className={styles.timeline__bar} ref={item => refBars.current[index] = item}></div>
                </div>
                {index < videoTimeParts.length - 1 ?
                  <div className={styles.timeline__dot} onClick={() => selectDot(index)} ref={item => refDots.current[index] = item}></div>
                  : null
                }
              </div>
            })}

          </div>
          : null}
        <Timer timerShown={timerShown} transitionJump={transitionJump} btnTexts={btnTexts} currentPartId={currentPartId} updateTimeline={updateTimeline} restartTrigger={restartTrigger} />
        <div className={styles.final} ref={refFinal}>
          <picture>
            <source media="(max-width: 1024px)" srcSet={`${path}/img/final-bg-mobile.webp`} />
            <img src={`${path}/img/final-bg.webp`} alt="" />
          </picture>
        </div>
        {isAutoplaytDisable ?
          <div className={styles.play} onClick={playHandler}><img src={`${path}/img/play-btn.svg`} alt="" /></div>
          :
          null
        }
        <div className={styles.subtitles} ><span ref={refSub}></span></div>
        <video src={`${path}/media/video-gpb${isMobile ? '-mobile' : ''}.mp4`} tabIndex="-1" role="application" playsInline muted={true} disablePictureInPicture ref={refVideo}>
          <track label='Русский' kind='metadata' srcLang='ru' src={`./subtitles/subtitles.vtt`} mode='hidden' default ref={refTrack} />
        </video>
      </div>
    </>
  );

}

export default Player;
